import React from "react";
import { NumericFormat } from "react-number-format";
import {
  profileDetailsSelector,
  profilePhotoSelector,
  selectedAccountSelector,
} from "../store/selectors/app.selector";
import { useSelector } from "react-redux";
import profileIcon from "../assests/new-images/profile_new.png";
import { useTranslation } from "react-i18next";

export default function AccountDisplayView() {
  const profileImage = useSelector(profilePhotoSelector);
  const selectedAccount = useSelector(selectedAccountSelector);
  const { t } = useTranslation();
  return (
    <div className="d-flex">
      <img
        src={
          profileImage != null && profileImage.length > 0
            ? `data:image/png;base64,${profileImage}`
            : profileIcon
        }
        alt="account"
        height={45}
        width={45}
      />
      <div style={{ marginLeft: 11 }}>
        <label>
          {t("pages.gepeg.source_account", {
            defaultValue: "Source Account",
          })}
        </label>{" "}
        <br />
        <span>{selectedAccount.accountNo}</span> <br />
        <p className="primary-color">
          {t("common.avl_bal", {
            defaultValue: "Avl Bal",
          })}
          :{" "}
          <span style={{ marginRight: 5 }}>
            {selectedAccount?.accountCurrency}
          </span>
          <NumericFormat
            value={selectedAccount?.avlBalance}
            displayType={"text"}
            thousandSeparator={true}
            prefix={""}
            fixedDecimalScale={true}
            decimalScale={2}
            allowEmptyFormatting
          />
        </p>
      </div>
    </div>
  );
}
